<template>
  <div class="private-ad-license-plate-lookup">
    <p class="error private-ad-license-plate-lookup__error" v-if="inputError">
      <span>{{ inputError }}</span>
      <span class="error__attention"></span>
    </p>
    <div class="private-ad-license-plate-lookup__inputs-container">
      <div class="private-ad-license-plate-lookup__container-input-search">
        <input
          class="private-ad-license-plate-lookup__input-search"
          type="text"
          placeholder="Skriv nummerplade her"
          v-model="licensePlateString"
          @keyup.enter="onSearch"
        />
      </div>
      <div class="private-ad-license-plate-lookup__container-button">
        <button
          :disabled="licensePlateString == '' || inProgress"
          class="private-ad-license-plate-lookup__button button button--highlight"
          @click="onSearch"
        >
          Indhent oplysninger
          <ButtonSpinner v-if="inProgress" />
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { app } from '@/main'
import ButtonSpinner from '@components/Shared/ButtonSpinner/ButtonSpinner.vue'

export default {
  components: {
    ButtonSpinner,
  },
  props: {
    eventBus: { default: null, type: Object },
    initialLicensePlate: { default: '', type: String },
    productTypeId: { default: null, type: Number },
    licensePlate: { default: '', type: String },
  },
  data() {
    return {
      inputError: '',
      licensePlateString: '',
      inProgress: false,
    }
  },
  methods: {
    setError(error) {
      this.inputError = error
    },
    onSearch() {
      this.eventBus.emit('private-ad-select-variant-list', {
        variantList: [],
        licensePlate: this.licensePlateString,
      })
      this.inProgress = true

      if (this.licensePlateString == '') {
        this.inputError = 'Nummerplade mangler'
        this.inProgress = false
        return false
      } else if (
        this.licensePlateString.length < 2 ||
        this.licensePlateString.length > 7
      ) {
        this.inputError = 'Nummerpladen skal være mellem 2-7 karakterer'
        this.inProgress = false
        return false
      } else if (this.licensePlateString.indexOf(' ') !== -1) {
        this.inputError = 'Nummerpladen må ikke indeholde mellemrum'
        this.inProgress = false
        return false
      } else this.inputError = ''

      app.axios
        .post('/api/PrivateAd/GetVariantsByLicensePlate', {
          licensePlate: this.licensePlateString,
          productTypeId: this.productTypeId,
        })
        .then(resp => {
          if (
            resp.data.errorCollection &&
            resp.data.errorCollection.length > 0
          ) {
            resp.data.errorCollection.forEach(value => {
              switch (value.errorItem) {
                case 'licensePlate':
                  app.toast.customWarning(JSON.parse(value.errorMessage))
                  break
                default:
                  break
              }
              this.inProgress = false
            })
          } else if (resp.data.data.length === 0) {
            this.inputError = 'Opslaget gav intet svar'
            app.toast.error(
              'Opslaget på din nummerplade gav intet svar. Kontroller nummerpladen for fejlindtastning eller udpeg køretøjet manuelt.'
            )
            this.inProgress = false
          } else {
            this.eventBus.emit('private-ad-select-variant-list', {
              variantList: resp.data.data,
              licensePlate: this.licensePlateString,
            })
            // Scroll down to variant list
            const element = document.getElementById('PrivateAdVariantList')
            if (element == null) return
            element.scrollIntoView({ behavior: 'smooth', block: 'start' })
            this.inProgress = false
          }
        })
    },
  },
  watch: {
    search() {
      this.inputError = ''
    },
    licensePlate(licensePlate) {
      if (this.licensePlateString === licensePlate) return

      this.licensePlateString = this.licensePlate
    },
    licensePlateString() {
      this.inputError = ''
    },
  },
  created() {
    window.scrollTo(0, 0)
    if (this.initialLicensePlate) {
      this.licensePlateString = this.initialLicensePlate
      this.onSearch()
    }
  },
}
</script>

<style lang="scss">
@import 'PrivateAdLicensePlateLookup.scss';
</style>
